import { useContext } from 'react'

import { SidebarContext, SidebarContextProps } from '../contexts/SidebarContext'

export const useSidebar = (): SidebarContextProps => {
  return useContext(SidebarContext)
}
